/* eslint-disable tailwindcss/no-custom-classname */
import { Container } from "@/components/molecules/Container";
import { Inner } from "@/components/molecules/Inner";
import Careers from "@/components/organisms/Careers";
import Contact from "@/components/organisms/Contact";
import { TermHead } from "@/components/organisms/TermHead";
import TermNav from "@/components/organisms/TermNav";
import { Footer } from "@/components/templates/Footer";
import { Header } from "@/components/templates/Header";
import Layout from "@/components/templates/Layout";
import Meta from "@/components/templates/Meta";
import { useBudouX } from "@/hooks/useBudouX";

const textBody = [
  {
    head: "プライバシー・ポリシーの適用範囲",
    body: "プライバシー・ポリシーは、本サービス内において株式会社トッカシステムズが利用者より取得する個人情報の取扱いに関して適用されます。なお、弊社が提供する各種サービス内において、別段の定めがある場合は、その定めが優先されます。",
  },
  {
    head: "用語の定義",
    body: "本サービス内において個人情報とは個人を特定し得る情報、即ち氏名、住所（市区町村情報まで）、メールアドレス、性別、その他の個人に関する属性情報をいうものとします。",
  },
  {
    head: "個人情報の取得、利用及び提供に関する方針",
    body: "株式会社トッカシステムズは、その事業内容及び規模を考慮し、個人情報の取得、利用及び提供を必要とする場合につきましては、ご提供者の同意を頂いた利用目的の範囲内で利用し、必要な範囲を超えた個人情報の取り扱いは行いません。また、お預かりした情報につきましては無断で第三者に提供する事はありません。",
  },
  {
    head: "個人情報の安全管理に関する方針",
    body: "株式会社トッカシステムズが取得した個人情報に対しては、安全性を考慮し、個人情報への不正アクセス、個人情報の紛失、破壊、改ざん及び漏洩等を防止する為、適切な予防並びに是正に関する対策を講じます。",
  },
  {
    head: "本サービス利用に関する方針",
    body: "本サービスの利用にあたり、利用者は個人情報を開示することなく本サービスを利用することができます。また、本サービスを利用しただけでは、利用者の個人情報が収集されることはありません。",
  },
  {
    head: "個人情報に関する法令及びその他規範の遵守に関する方針",
    body: "株式会社トッカシステムズは、個人情報保護に関する法律及び関連する法規範を遵守します。",
  },
  {
    head: "継続的改善に関する方針",
    body: "株式会社トッカシステムズは、個人情報保護マネジメントシステムの継続性改善に努めます。",
  },
  {
    head: "個人情報に関する相談及び苦情窓口",
    body: "本サービスの個人情報に関する苦情、相談は、お問い合わせフォームより行ってください。",
  },
];

export default function PolicyPage() {
  const { parse } = useBudouX();
  const isHeaderRelative = true;
  return (
    <>
      <Meta
        pageTitle={"プライバシー・ポリシー"}
        pageDescription={
          "株式会社トッカシステムズのプライバシー・ポリシーです。日進月歩のデジタルテクノロジー分野において『お客様のビジネスに特化（Tocca）したシステムを』という理念を社名に込めて、使える・価値のあるシステムを提供します。"
        }
        pagePath={"https://tocca.systems/policy/"}
      />
      <Layout>
        <Header isRelative={isHeaderRelative} />
        <main className="flex-1">
          <Container>
            <Inner className="mx-auto box-border flex max-w-6xl flex-col py-10 px-6 text-pri sm:px-8 md:px-12 md:pt-16 md:pb-24">
              <TermNav />
              <div className="order-1 md:order-2">
                <TermHead className="mb-4 md:mb-7">
                  プライバシー・ポリシー
                </TermHead>
                <div className="border-x-0 border-t-0 border-b border-solid border-bdc-light px-0 pb-8 text-base text-txt-light md:mb-8 md:px-16 md:pb-8 md:text-md">
                  <p>
                    {parse(
                      "株式会社トッカシステムズは、本サイト、並びに弊社が提供する各種サービス（以下、本サービスとします）における利用者の個人情報保護を目的として、プライバシー・ポリシーを定め、プライバシー・ポリシーに基づき、利用者、ならびに利用会員より取得した個人情報を取り扱うものとします。"
                    )}
                  </p>
                  <p>
                    {parse(
                      "つきましては、本サイトのご利用にあたって、以下のプライバシー・ポリシーをお読み下さい。"
                    )}
                  </p>
                </div>
                <div className="grid-rows-8 grid space-y-2 divide-y divide-x-0 divide-solid divide-bdc-light text-base text-txt-base md:space-y-2">
                  {textBody.map((textBody) => (
                    <dl
                      key={textBody.head}
                      className=" grid grid-flow-dense grid-cols-none pt-2 md:grid-flow-col md:grid-cols-3 md:gap-12"
                    >
                      <dt className="col-auto inline-block font-bold leading-8 text-pri md:col-span-1 md:text-txt-light">
                        <div
                          dangerouslySetInnerHTML={{ __html: textBody.head }}
                        />
                      </dt>
                      {/* <dd
                        className="col-auto	leading-8 md:col-span-3"
                        dangerouslySetInnerHTML={{ __html: parse(textBody.body) }}
                      /> */}
                      <dd className="col-auto	leading-8 md:col-span-2">
                        {parse(textBody.body)}
                      </dd>
                    </dl>
                  ))}
                </div>
              </div>
            </Inner>
          </Container>
        </main>
        <Careers />
        <Contact />
        <Footer />
      </Layout>
    </>
  );
}
